import {NgModule} from '@angular/core';
import {ModalFooterComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {ButtonComponentModule} from '../button/item.module';

@NgModule({
  imports: [
    IonicModule,
    NgStyle,
    NgClass,
    NgIf,
    ButtonComponentModule
  ],
  exports: [
    ModalFooterComponent
  ],
  declarations: [ModalFooterComponent],
  providers: [],
})
export class ModalFooterComponentModule {
}
